<template>
  <PeriodeForm mode="Ubah" module="Periode"> </PeriodeForm>
</template>

<script>
import PeriodeForm from './form';

const PeriodeUpdate = {
  name: 'PeriodeUpdate',
  components: { PeriodeForm },
};

export default PeriodeUpdate;
</script>
